import { mutator } from "satcheljs";
import { onInteractionRequiredAuthFailure } from "owa-msaljs";
import { getStore } from "owa-app-auth-ui-store";

export const onAuthFailure: (actionMessage: {}) => void = mutator(onInteractionRequiredAuthFailure, () => {
    const store = getStore();
    if (!store.isSignInRequired) {
        store.isSignInRequired = true;
    }
});
